module.exports = __webpack_public_path__ + "static/dashboard_Sponsorship@2x-bfb0620187e530c61f56ab1d56c58298.jpg";